"use client";
import { Grid, Stack } from "@mui/material";
import React from "react";
import SignupSection from "./signup-section/SignUpSection";
import LoanNavigationMenu from "./components/SectionMenu/LoanNavigationMenu";
import VideoCarousel from "./components/VideoCarousel";
import BlogCarouselComponent from "./components/BlogCarousel/BlogCarouselComponent";
import AppPromoImage from "./components/Promo/AppPromoImage";
import NewsletterSection from "./components/Subscription/NewsLetterSubscription";
import Footer from "./components/Footer/Footer";
import LandingPageProvider from "./context/provider";
import { useSearchParams } from "next/navigation";
import { useSelector } from "react-redux";

const LandingScreen = () => {
  const { afUserId } = useSelector((state) => state?.af);
  const searchParams = useSearchParams();
  const params = {
    utmSource: searchParams.get("utm_source"),
    utmMedium: searchParams.get("utm_medium"),
    utmTerm: searchParams.get("utm_term"),
    utmAdsetid: searchParams.get("utm_adsetid"),
    utmCampaign: searchParams.get("utm_campaign"),
    utmNetwork: searchParams.get("utm_network"),
    utmMatchtype: searchParams.get("utm_matchtype"),
    utmDevice: searchParams.get("utm_device"),
    utmPlacement: searchParams.get("utm_placement"),
    utmContent: searchParams.get("utm_content"),
    utmAdposition: searchParams.get("utm_adposition"),
    utmLocation: searchParams.get("utm_location"),
    utmSitelink: searchParams.get("utm_sitelink"),
    utmAudience: searchParams.get("utm_audience"),
    utmPromotion: searchParams.get("utm_promotion"),
    utmPrice: searchParams.get("utm_price"),
    utmCampaignid: searchParams.get("utm_campaignid"),
    gadSource: searchParams.get("gad_source"),
    gclid: searchParams.get("gclid"),
    utmCampaigntype: searchParams.get("utm_campaigntype"),
  };
  const fbparams = {
    source: searchParams.get("utm_source"),
    medium: searchParams.get("utm_medium"),
    term: searchParams.get("utm_term"),
    adsetid: searchParams.get("utm_adsetid"),
    campaign: searchParams.get("utm_campaign"),
    network: searchParams.get("utm_network"),
    matchtype: searchParams.get("utm_matchtype"),
    device: searchParams.get("utm_device"),
    placement: searchParams.get("utm_placement"),
    content: searchParams.get("utm_content"),
    adposition: searchParams.get("utm_adposition"),
    location: searchParams.get("utm_location"),
    sitelink: searchParams.get("utm_sitelink"),
    audience: searchParams.get("utm_audience"),
    promotion: searchParams.get("utm_promotion"),
    price: searchParams.get("utm_price"),
    campaign_id: searchParams.get("utm_campaignid"),
    gad_source: searchParams.get("gad_source"),
    campaign_type: searchParams.get("utm_campaigntype"),
  };
  return (
    <LandingPageProvider>
      <Grid>
        <Stack>
          <SignupSection
            params={params}
            afUserId={afUserId}
            fbparams={fbparams}
          />
        </Stack>
        <Stack>
          <LoanNavigationMenu />
        </Stack>
        <Stack>
          <VideoCarousel />
        </Stack>
        <Stack>
          <BlogCarouselComponent />
        </Stack>
        <Stack>
          <AppPromoImage />
        </Stack>
        <Stack>
          <NewsletterSection />
        </Stack>
        <Stack>
          <Footer />
        </Stack>
      </Grid>
    </LandingPageProvider>
  );
};

export default LandingScreen;
